// Formatting helpers used across the app.

export const formatPrice = (value, isRental = false) => {
  if (value == null) return '—';
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
  return isRental ? `${formatted}/mo` : formatted;
};

export const formatCompactPrice = (value) => {
  if (value == null) return '—';
  if (value >= 1000000) return `$${(value / 1000000).toFixed(value % 1000000 === 0 ? 0 : 1)}M`;
  if (value >= 1000) return `$${Math.round(value / 1000)}K`;
  return `$${value}`;
};

export const formatNumber = (value) => new Intl.NumberFormat('en-US').format(value ?? 0);

export const formatDaysOnMarketShort = (days) => {
  if (days == null) return '—';
  if (days === 0) return 'New';
  if (days === 1) return '1 Day';
  return `${days} Days`;
};

export const slugify = (str = '') =>
  str.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const STATUS_LABELS = {
  for_sale: 'For Sale',
  for_rent: 'For Rent',
  sold: 'Sold',
  new_construction: 'New Construction',
};

export const PROPERTY_TYPES = ['Residential', 'Condo', 'Commercial', 'Land'];

export const PROPERTY_TYPE_LABELS = {
  Residential: 'Single Family / Multi-Family',
  Condo: 'Condo',
  Commercial: 'Commercial',
  Land: 'Land',
};
